/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
	PMREMGenerator,
	PerspectiveCamera,
	SRGBColorSpace,
	Scene,
	WebGLRenderer,
} from 'three';

import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';

export const setupScene = () => {
	const scene = new Scene();

	const camera = new PerspectiveCamera(
		70,
		window.innerWidth / window.innerHeight,
		0.01,
		5000,
	);

	const renderer = new WebGLRenderer({ antialias: true, alpha: true });
	renderer.setPixelRatio(window.devicePixelRatio);
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.outputColorSpace = SRGBColorSpace;
	renderer.xr.enabled = true;
	document.getElementById('scene-container').appendChild(renderer.domElement);

	const pmremGenerator = new PMREMGenerator(renderer);
	pmremGenerator.compileEquirectangularShader();

	new EXRLoader().load('assets/venice_sunset_1k.exr', (texture) => {
		const envMap = pmremGenerator.fromEquirectangular(texture).texture;
		pmremGenerator.dispose();
		scene.environment = envMap;
	});

	const onResize = () => {
		const width = document.getElementById('scene-container').offsetWidth;
		const height = document.getElementById('scene-container').offsetHeight;
		camera.aspect = width / height;
		camera.updateProjectionMatrix();

		renderer.setSize(width, height);
	};

	window.addEventListener('resize', onResize);

	window.addEventListener('load', onResize);

	renderer.xr.setFramebufferScaleFactor(2);

	return { scene, camera, renderer };
};
